import React from "react";

// react-bootstrap components
import {
  Badge,
  Button,
  Card,
  Navbar,
  Nav,
  Table,
  Container,
  Row,
  Col,
} from "react-bootstrap";

function TableList() {
  return (
    <>
      <Container fluid>
        <Row>
          <Col md="12">
            <Card className="strpied-tabled-with-hover">
              <Card.Header>
                <Card.Title as="h4">학력사항</Card.Title>
              </Card.Header>
              <Card.Body className="table-full-width table-responsive px-0">
                <Table className="table-hover table-striped info-table">
                  <thead>
                    <tr>
                      <th className="border-0">기간</th>
                      <th className="border-0">학교명</th>
                      <th className="border-0">구분</th>
                      <th className="border-0">상태</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td data-label="기간">2018.01 ~ 현재</td>
                      <td data-label="학교명">
                        <strong>KG ITBANK (학점은행제)</strong>
                      </td>
                      <td data-label="구분">대학교</td>
                      <td data-label="상태">126학점 누적, 재학중</td>
                    </tr>
                    <tr>
                      <td data-label="기간">2014.03 ~ 2017.03</td>
                      <td data-label="학교명">
                        <strong>세명컴퓨터고등학교</strong>
                      </td>
                      <td data-label="구분">고등학교</td>
                      <td data-label="상태">졸업</td>
                    </tr>
                  </tbody>
                </Table>
              </Card.Body>
            </Card>
          </Col>
          <Col md="12">
            <Card className="strpied-tabled-with-hover">
              <Card.Header>
                <Card.Title as="h4">경력사항</Card.Title>
                <p className="card-category">
                  총 5년 1개월
                </p>
              </Card.Header>
              <Card.Body className="table-full-width table-responsive px-0">
                <Table className="table-hover table-striped career-table">
                  <thead>
                    <tr>
                      <th className="border-0">기간</th>
                      <th className="border-0">회사명</th>
                      <th className="border-0">부서명</th>
                      <th className="border-0">직무</th>
                      <th className="border-0">직급</th>
					  <th className="border-0">성과</th>
					  <th className="border-0">연봉</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>2026.05 ~ 2026.10</td>
                      <td>웰파인</td>
                      <td>DX혁신팀</td>
                      <td>웹개발</td>
                      <td>사원</td>
					  <td>웰파인 자체 운영(swp)<br/>
* 작업한 화면<br/>
1. 견적서 등록<br/>
2. 견적서 현황<br/>
3. 견적서 인쇄 미리보기<br/>
4. 스틱/롤 발주기준 팝업<br/>
5. 포장사양서 등록<br/>
6. 포장사양서 현황<br/>
7. 포장사양서 인쇄 미리보기<br/>
8. 포장사양서 사진 확대 팝업<br/>
9. 배합비 등록<br/>
10. 배합비 현황<br/>
<br/>
vue.js, ag-grid<br/>
총 12개 페이지제작<br/>
11개 테이블 생성<br/>
30개 프로시저 생성<br/>
6개 계발설계서 ppt 제작<br/>
총 10개 화면 QA테스트 까지 다함<br/>
<br/>
프론트엔드(vue.js+ag-grid)+백엔드(테이블 설계, 프로시저 설계)+DBA+QA 까지 다한셈</td>
 <td>4000만원</td>
                    </tr>
                    <tr>
                      <td>2025.07 ~ 2026.04</td>
                      <td>이룬소프트</td>
                      <td></td>
                      <td>웹개발</td>
                      <td>사원</td>
					  <td>* 기존 퍼스트몰 쇼핑몰 커스텀 소스 유지보수 및 개발 (에이프/블링크/위핑)<br/>
- 약 60개 이상의 요청사항들을 수정/해결 완료함<br/>
- 속도 개선, 카테고리 필터, 에러 해결, 상품 노출, 레이아웃 구조, 특정 컬럼 출력 등등<br/>
- 퍼스트몰 신규패치 소스 적용<br/>
- 기존 위핑 사이트 신규몰 이전 작업 수행<br/>
<br/>
* 쇼미3 웹개발(관리자, 사용자)<br/>
- ppt 메뉴얼 제작, 엑셀파일로 소스 분석 기록<br/>
- 톰캣(backend, controller) + 아파치(view) 구조로 개발<br/>
- 관리자 view단 페이지 50퍼센트 완료<br/>
- 기존 쇼미3 사용자/관리자단 sql문 마이그레이션(oracle -> mysql) 완료<br/>

<br/>
* 위핑/블링크 사이트 고객 cs 응대<br/>
- 고객 전화 응대 및 퍼스트몰 관리자단에서 주문건 조회 및 안내</td>
<td>3600만원</td>
                    </tr>
                    <tr>
                      <td>2025.04 ~ 2025.06</td>
                      <td>아모레보미</td>
                      <td>마케팅팀</td>
                      <td>퍼블리셔</td>
                      <td>사원</td>
					  <td>* 업무 & 프로젝트명<br/>
다시봄날의원 지점별 웹사이트 아임웹 + 카페24 호스팅 mysql api로 연동 DB화<br/>
<br/>
* 활용 기술<br/>
php, mysql, javascript, 반응형, 웹표준(html5 + css3 + jquery), ftp(파일질라), 카페24 호스팅(뉴아우토반호스팅 비즈니스), 아임웹, Splide.js, dbeaver, 구글 reCAPTCHA<br/>
<br/>
주요 역할 : DBA, QA테스터, 퍼블리싱, 웹사이트 관리<br/>
<br/>
* 주요성과<br/>
1. 기존에 아임웹 디자인모드 예약_추가수정 페이지에서 기존 개발자분(대리님)이 고전하던 스크립트, 퍼블리싱 에러들 해결 완료<br/>
2. 아임웹에서 api통신을 통해, 기존에 아모레보미 카페24호스팅 안에있는 DB와 api통신을 이용해(php파일을 카페24 호스팅에 업로드) db화 완료(기존의 코딩은 하드코딩이라서 일일이 상품을 html로 입력/수정하는방식 이였는데, 제가 그걸 DB에서 sql문으로 수정하는방식으로 변경)<br/>
3. 카페24호스팅 안에있는 DB에 6개 지점 각각 지점별로 테이블 6개 성성, php파일 6개 생성 각 테이블 마다 각지점별로 상품 정보 레코드 sql insert 완료<br/>
4. QA테스트로 대리님과 소통하면서 데이터가 잘전송되는지(베가스라는 응용프로그램에 데이터가 전송되는지) 확인, 기타 에러나 오류들 해결 완료<br/>
5. 구글 reCAPTCHA 모달 팝업창에 적용 및 구글 reCAPTCHA 관리자페이지에서 모니터링<br/>
6. Splide.js를 사용해서 팝업 슬라이드 생성(PC/모바일단 전부다)<br/>
7. 주의사항 페이지 제작 완료(jquery-ui 아코디언메뉴)<br/>
8. 다시봄날의원 (지축, 평택, 의정부, 안산, 김포, 부평) 각 이벤트 페이지 제작 완료(이벤트 예약 페이지)<br/>
9. 다시봄날의원 (지축, 평택, 의정부, 안산, 김포, 부평) 각 이벤트 페이지 적용 후 유지보수 응대</td>
					  <td>3600만원</td>
                    </tr>
                    <tr>
                      <td>2024.03 ~ 2024.12</td>
                      <td>동아피엠</td>
                      <td>개발 5파트</td>
                      <td>웹개발</td>
                      <td>사원</td>
					  <td>
- 동아피엠 포털 사이트 자원예약 프로젝트 리뉴얼 진행<br/>
- 리눅스 설치 메뉴얼 파워포인트 제작<br/>
- 원헌드레드 HID 출입통제 개발</td>
					  <td>3200만원</td>
                    </tr>
                    <tr>
                      <td>2023.09 ~ 2024.01</td>
                      <td>데이타늄</td>
                      <td>웹개발부</td>
                      <td>웹개발</td>
                      <td>사원</td>
					  <td>2023 영화 정보 시스템 통합 위탁 운영 용역<br/>
​웹개발 유지 보수 및 si<br/>
대표홈페이지 kofic 사이트 리뉴얼 및 기존 사이트 유지 보수</td>
					  <td>3200만원</td>
                    </tr>
                    <tr>
                      <td>2023.05 ~ 2023.08</td>
                      <td>와우큐브</td>
                      <td></td>
                      <td>웹개발</td>
                      <td>사원</td>
					  <td>IPCC 웹개발 및 유지보수 관리자 / CRM 페이지</td>
					  <td>3200만원</td>
                    </tr>
					<tr>
                      <td>2021.08 ~ 2022.10</td>
                      <td>와이즈아이씨티 </td>
                      <td></td>
                      <td>파견직 IT</td>
                      <td>대리</td>
					  <td>1) 프로젝트명: 웹 db 업그레이드 대비 테스트 페이북<br/>

- 연계/소속회사 : 비씨카드/와이즈아이씨티<br/>

- 수행 기간 : 2021.08 ~ 2021.11 (약 3개월)<br/>

- 주요 역할 : 페이북 앱 테스트<br/>

- 업무 성과 : 엑셀파일에다가 페이지마다 테스트기록 표기<br/>


2) 프로젝트명: bnk 앱개발 테스트<br/>

- 연계/소속회사 : 신한아이타스/와이즈아이씨티<br/>

- 수행 기간 : 2021.12 ~ 2022.02 (약 3개월)<br/>

- 주요 역할 : bnk 앱/웹 테스트<br/>

- 업무 성과 : 엑셀파일에다가 페이지마다 테스트기록 표기<br/>
<br/>

3) 프로젝트명: 현대카드 대출비교 프로세스 리뉴얼<br/>

- 연계/소속회사 : 현대카드/와이즈아이씨티<br/>

- 수행 기간 : 2022.05 ~ 2022.07 (약 3개월)<br/>

- 주요 역할 : 웹개발<br/>

- 사용 기술 : 전자정부프레임워크, Java, Tomcat, Oracle, SVN, WAS : linux<br/>
<br/>

4) 프로젝트명: new security portal<br/>

- 연계/소속회사 : LG CNS/와이즈아이씨티<br/>

- 수행 기간 : 2022.09 ~ 2022.10 (약 2개월)<br/>

- 주요 역할 : 웹개발<br/>

- 사용 기술 : Spring Boot, Tomcat, Java, WAS : linux
</td>
					  <td>3000만원</td>
                    </tr>
					<tr>
                      <td>2020.11 ~ 2021.04</td>
                      <td>링인터랙티브</td>
                      <td>lms기획</td>
                      <td>웹개발</td>
                      <td>사원</td>
					  <td>나의학습방,듀냐학습관리 퍼블리싱 및 sql 마이그레이션(oracle sql -> mysql 로 sql문 문법변환)
</td>
					  <td>2400만원</td>
                    </tr>
					<tr>
                      <td>2017.09 ~ 2017.11</td>
                      <td>상록영상</td>
                      <td>웹퍼블리셔부</td>
                      <td>퍼블리셔</td>
                      <td>인턴</td>
					  <td>디지털교과서 사회단원<br/>
프로젝트 레이아웃 및 css수정
</td>
					  <td>1920만원</td>
                    </tr>
                  </tbody>
                </Table>
              </Card.Body>
            </Card>
          </Col>
          <Col md="12">
            <Card className="strpied-tabled-with-hover">
              <Card.Header>
                <Card.Title as="h4">자격/어학/수상</Card.Title>
                <p className="card-category">보유 자격증 및 수상 내역</p>
              </Card.Header>
              <Card.Body className="table-full-width table-responsive px-0">
                <Table className="table-hover table-striped info-table">
                  <thead>
                    <tr>
                      <th className="border-0">취득일</th>
                      <th className="border-0">자격증명</th>
                      <th className="border-0">결과</th>
                      <th className="border-0">발급기관</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td data-label="취득일">2021.12</td>
                      <td data-label="자격증명"><strong>네트워크관리사2급</strong></td>
                      <td data-label="결과">최종합격</td>
                      <td data-label="발급기관">한국정보통신자격협회</td>
                    </tr>
                    <tr>
                      <td data-label="취득일">2019.12</td>
                      <td data-label="자격증명"><strong>컴퓨터활용능력1급</strong></td>
                      <td data-label="결과">최종합격</td>
                      <td data-label="발급기관">대한상공회의소</td>
                    </tr>
                    <tr>
                      <td data-label="취득일">2017.03</td>
                      <td data-label="자격증명"><strong>GTQ일러스트 1급</strong></td>
                      <td data-label="결과">최종합격</td>
                      <td data-label="발급기관">한국생산성본부(KPC)</td>
                    </tr>
                    <tr>
                      <td data-label="취득일">2016.10</td>
                      <td data-label="자격증명"><strong>컴퓨터그래픽스운용기능사</strong></td>
                      <td data-label="결과">최종합격</td>
                      <td data-label="발급기관">한국산업인력공단</td>
                    </tr>
                    <tr>
                      <td data-label="취득일">2016.10</td>
                      <td data-label="자격증명"><strong>웹디자인기능사</strong></td>
                      <td data-label="결과">최종합격</td>
                      <td data-label="발급기관">한국산업인력공단</td>
                    </tr>
                    <tr>
                      <td data-label="취득일">2015.08</td>
                      <td data-label="자격증명"><strong>컴퓨터활용능력2급</strong></td>
                      <td data-label="결과">최종합격</td>
                      <td data-label="발급기관">대한상공회의소</td>
                    </tr>
                    <tr>
                      <td data-label="취득일">2015.04</td>
                      <td data-label="자격증명"><strong>정보처리기능사</strong></td>
                      <td data-label="결과">최종합격</td>
                      <td data-label="발급기관">한국산업인력공단</td>
                    </tr>
                    <tr>
                      <td data-label="취득일">2014.09</td>
                      <td data-label="자격증명"><strong>GTQ포토샵1급</strong></td>
                      <td data-label="결과">최종합격</td>
                      <td data-label="발급기관">한국생산성본부(KPC)</td>
                    </tr>
                    <tr>
                      <td data-label="취득일">2014.07</td>
                      <td data-label="자격증명"><strong>워드프로세서1급</strong></td>
                      <td data-label="결과">최종합격</td>
                      <td data-label="발급기관">대한상공회의소</td>
                    </tr>
                  </tbody>
                </Table>
              </Card.Body>
            </Card>
          </Col>
          <Col md="12">
            <Card className="strpied-tabled-with-hover">
              <Card.Header>
                <Card.Title as="h4">교육이수내역</Card.Title>
                <p className="card-category">참여한 교육 과정</p>
              </Card.Header>
              <Card.Body className="table-full-width table-responsive px-0">
                <Table className="table-hover table-striped info-table">
                  <thead>
                    <tr>
                      <th className="border-0">기간</th>
                      <th className="border-0">교육기관</th>
                      <th className="border-0">구분</th>
                      <th className="border-0">교육내용</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td data-label="기간">2016.05 ~ 2016.12</td>
                      <td data-label="교육기관"><strong>대양전문직업학교</strong></td>
                      <td data-label="구분">
                        <Badge pill bg="secondary">교육이수내역</Badge>
                      </td>
                      <td data-label="교육내용">
                        photoshop, illustrator, dreamweaver, html하드코딩, 웹표준,
                        html5, css3, 반응형웹, jquery, 쇼핑몰 제작 및 운영,
                        상품상세페이지디자인, 한글, excel
                      </td>
                    </tr>
                    <tr>
                      <td data-label="기간">2015.11 ~ 2015.12</td>
                      <td data-label="교육기관"><strong>글로벌숙련기술진흥원</strong></td>
                      <td data-label="구분">
                        <Badge pill bg="secondary">교육이수내역</Badge>
                      </td>
                      <td data-label="교육내용">숙련기술 이수</td>
                    </tr>
                    <tr>
                      <td data-label="기간">2018.01 ~ 2018.07</td>
                      <td data-label="교육기관"><strong>KGITBANK 연지점</strong></td>
                      <td data-label="구분">
                        <Badge pill bg="secondary">교육이수내역</Badge>
                      </td>
                      <td data-label="교육내용">보안관제, 모의해킹 교육 이수</td>
                    </tr>
                    <tr>
                      <td data-label="기간">2020.02 ~ 2020.07</td>
                      <td data-label="교육기관"><strong>한국소프트웨어 인재개발원</strong></td>
                      <td data-label="구분">
                        <Badge pill bg="secondary">교육이수내역</Badge>
                      </td>
                      <td data-label="교육내용">
                        블록체인기반 핀테크플랫폼구축 개발자 양성과정
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default TableList;
